var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"my-5 display-4 text-center text-muted"},[_vm._v("Page not found")])])
}]

export { render, staticRenderFns }